<template>
  <div :class="['overlay-modal', windowHeight < 1000 ? 'scroll' : '']">
    <Loader :isVisible="isLoading" />
    <div class="back-btn">
      <Button
        :className="'back-local'"
        :title="'Back to Feed Settings'"
        :srcSvg="iconBackTo"
        :eventFunction="toFeed"
        :hasBorder="true"
      />
    </div>
    <div class="main-tabs-container">
      <Tabs>
        <Tab
          id="localization"
          name="Localization"
          :selected="true"
          class="wrapper-general"
        >
          <div class="flex">
            <div class="eng-local-wrapper">
              <div class="pb-13">
                English (default)
              </div>
              <div class="eng-local-container">
                <FeedEngForm :feed="feed" />
              </div>
            </div>
            <div class="translate-local-wrapper">
              <Tabs
                :removeMargin="true"
                :onSelectTab="handleSelectTab"
              >
                <Tab
                  v-for="lang in enabledLanguages"
                  :id="lang.name"
                  :key="lang.id"
                  :name="lang.name"
                  :selected="formData.mode === lang.name"
                  :isLocalisation="true"
                  :className="[isEditedForm.length
                    && isEditedForm.find(item => item.id === lang.id && !!item.value)
                    ? 'error-tab'
                    : 'tab']"
                >
                  <TranslateFeedForm
                    :lang="lang"
                    :feed="feed"
                    :enabledLanguages="enabledLanguages"
                    :selected="formData.mode === lang.name"
                    @changedLanguage="changedLanguage"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
} from 'vuex';
import Button from '../common/Button.vue';
import Tabs from '../common/Tabs/Tabs.vue';
import Tab from '../common/Tabs/Tab.vue';
import iconBackTo from '../../assets/icons/icon-back-to.svg';
import { GET_LANGUAGES_REQUEST, SET_FORM_CHANGES } from '../../store/actions/localization/localizationActions';
import Loader from '../common/Loader.vue';
import FeedEngForm from '../forms/localization/FeedEngForm.vue';
import TranslateFeedForm from '../forms/localization/TranslateFeedForm.vue';

export default {
  name: 'FeedLocalization',
  components: {
    TranslateFeedForm,
    FeedEngForm,
    Loader,
    Button,
    Tabs,
    Tab,
  },
  props: {
    onClose: {
      type: Function,
      default: () => {},
      required: false,
    },
    feed: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      iconBackTo,
      windowHeight: window.outerHeight,
      enabledLanguages: [],
      formData: {
        mode: '',
        changedLanguage: {},
      },
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.localization.isLoading,
      isEditedForm: (state) => state.localization.isEditedForm,
    }),
    ...mapGetters([
      'getLanguages',
    ]),
  },
  created() {
    window.addEventListener('resize', this.onResize);
    const params = {
      accountId: this.getCurrentAccountId,
      page: 1,
      limit: 1000,
      filterValue: '',
    };
    this.$store.dispatch(GET_LANGUAGES_REQUEST, params).then((res) => {
      this.enabledLanguages = res.data;
      this.formData.mode = res.data && res.data[0].name;
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    toFeed() {
      this.onClose();
    },
    handleSelectTab(id) {
      this.formData.mode = id;
      this.$store.dispatch(SET_FORM_CHANGES, this.formData.changedLanguage);
    },
    onResize() {
      this.windowHeight = window.outerHeight;
    },
    changedLanguage(value) {
      this.formData.changedLanguage = value;
    },
  },
};
</script>

<style scoped lang="scss">
.overlay-modal {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: 95%;
  background: #222222;
  z-index: 999;
}

.scroll {
  overflow: auto;
}

.back-btn {
  padding-top: 20px;
  padding-left: 20px;
}

.main-tabs-container {
  padding: 10px 20px 30px;
}

.eng-local-wrapper {
  width: 40%;
}

.eng-local-container {
  border-top: 2px solid var(--gray);
  border-right: 2px solid var(--gray);
  height: 73vh;
}

.pb-13 {
  padding-bottom: 15px;
  line-height: 15px;
}

.translate-local-wrapper {
  width: 60%;
}

.flex {
  display: flex;
  align-items: flex-start;
}

.back-local {
  padding-left: 0;
}

@media all and (max-height: 930px)  {
  .eng-local-container {
    height: 71vh;
  }
}

@media all and (max-height: 890px)  {
  .eng-local-container {
    height: 70vh;
  }
}

@media all and (max-height: 830px)  {
  .eng-local-container {
    height: 76vh;
  }
}

@media all and (max-height: 790px)  {
  .eng-local-container {
    height: 90vh;
  }
}
</style>
